import styled from "styled-components";

export const TitleButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`